import React from 'react';

import { BREAK_POINT } from 'constants/responsive';
import './VideoFeedItem.sass';

interface IProps {
    className?: string;
    videoId: string;
    videoTitle: string;
    videoDuration: string;
    videoChannel: string;
    videoViews: number;
    videoThumbnailSrc: string;
}

const VideoFeedItem: React.StatelessComponent<IProps> = (props) => {
    return(
        <div className={`VideoFeedItem-container${window.innerWidth < BREAK_POINT ? '-mobile' : ''}${props.className ? ` ${props.className}` : ''}`}>
            <div className="Thumbnail">
                <span className="Image">
                    <a target="_blank" href={`https://www.youtube.com/watch?v=${props.videoId}`}>
                        <img src={props.videoThumbnailSrc} />
                        <span className="Duration-overlay">{props.videoDuration}</span>
                    </a>
                </span>
            </div>
            <div className="Info">
                <span className="Title"><a target="_blank" href={`https://www.youtube.com/watch?v=${props.videoId}`}>{props.videoTitle}</a></span>
                <span className="Channel">{props.videoChannel}</span>
                <span className="Views">{props.videoViews / 1000 > 1 ? `${Math.round(props.videoViews / 100) / 10}K Views` : `${props.videoViews} Views`}</span>
            </div>
        </div>
    );
};

export default VideoFeedItem;



// WEBPACK FOOTER //
// ./src/components/global/application/video/VideoFeedItem.tsx